import axios from 'axios'
import router from '../router'
import store from '../store'
import auth from '../auth'
import NProgress from 'nprogress'
import {API_HOST} from "@/localSettings"
import {objectSize} from '../utils'

const http = axios.create({
  baseURL: API_HOST
})

const handleError = function(errors, propName = false) {
  if (typeof errors === 'object' && objectSize(errors) > 0) {
    for (let prop in errors) {
      if (typeof errors[prop] === 'object') {
        handleError(errors[prop], prop)
      } else if (typeof errors[prop] === 'string') {
        store.commit('ERROR', `${propName ? propName : prop}: ${errors[prop]}`)
      }
    }
  }
}

http.interceptors.request.use(request => {
  if (!('__silent' in request)) {
    NProgress.start()
    store.commit('SET_LOADING', true)
  }
  return request
})

http.interceptors.response.use(response => {
  if (!('__silent' in response.config)) {
    NProgress.done()
    store.commit('SET_LOADING', false)
  }
  return response
}, error => {
  if (!('__silent' in error.config)) {
    NProgress.done()
    store.commit('SET_LOADING', false)
  }
  if (error.message === "Network Error") {
    store.commit('NETWORK_ERROR', true)
    return Promise.reject()
  } else if (error.response.status === 400) {
    handleError(error.response.data)
  } else if (error.response.status === 413) {
    store.commit('ERROR', 'Размер загружаемого файла слишком велик.')
  } else if (error.response.status === 404) {
    //TODO: turn off debug
    alert("ОШИБКА 404\n\n" + JSON.stringify(error.response));
    //router.push({name: '404'})
  } else if (error.response.status === 401) {
    auth.unbind()
    router.push({name: 'login'})
  }
  return Promise.reject(error)
})

export default {
  install(Vue, options) {
    Vue.prototype.$axios = Vue.axios = http
    Vue.prototype.$http = Vue.http = this
  },
  setHeader(key, value) {
    http.defaults.headers.common[key] = value
  },
  removeHeader(key) {
    delete http.defaults.headers.common[key]
  }
}
